
import React, { useState, Fragment } from 'react';
import { MainNav } from './utils/menu2';
import IconButton from '@material-ui/core/IconButton';
import BurgerMenu from 'react-burger-menu';
import {
    AiOutlineHome,
    AiOutlineUser,
    AiOutlineFileText,
    AiOutlineMonitor,
    AiOutlineSchedule,
    AiOutlineQuestion,
    AiOutlineFileProtect,
    AiOutlineMail,
    AiOutlineUsergroupAdd,
    AiOutlineDollarCircle,
    AiOutlineClockCircle
} from 'react-icons/ai';
import { CgLogOut } from 'react-icons/cg';
import { Link } from "react-router-dom";

//Redux
import { connect } from 'react-redux';

//Utils
import { userRolValidationWithMail } from '../../utils/userValidation/rolValidation'
import { useEffect } from 'react';

//Auth0
import { useAuth0 } from "@auth0/auth0-react";

const mapStateToProps = state => ({
    usuarioActivo: state
})

const GeneralMenu = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [openDropdowns, setOpenDropdowns] = useState([]);
    const Menu = BurgerMenu['slide'];
    const { logout } = useAuth0();
    
    const handleStateChange = (e) => {
        props.setMenuVisible(e.isOpen)
    }

    const isIndependentItem = (item) => {
        return item.label === 'Home' || item.label === 'Perfil de Usuario';
    }

    const isTalentoHumanoItem = (item) => {
        return ['Proceso de Aprobaciones', 'Proceso de Selección', 'Proceso de Contratación', 
                'Historico Solicitudes', 'Gestión de contratos', 'Reporte a Nómina'].includes(item.label);
    }

    const isVinculacionPersonalItem = (item) => {
        return ['Fecha Contratación', 'Cargue Contrato'].includes(item.label);
    }

    const isDesvinculacionPersonalItem = (item) => {
        return ['Proceso paz y salvo'].includes(item.label);
    }

    const isOtrosItem = (item) => {
        return ['Gestión de Usuarios', 'Envio de Correo Masivo', 'Informe APE'].includes(item.label);
    }

    const handleDropdownToggle = (dropdownName) => {
        setOpenDropdowns(prev => {
            if (prev.includes(dropdownName)) {
                return prev.filter(name => name !== dropdownName);
            } else {
                return [...prev, dropdownName];
            }
        });
    }

    const isDropdownOpen = (dropdownName) => {
        return openDropdowns.includes(dropdownName);
    }

    const handleLogout = () => {
        localStorage.removeItem('userData')
        localStorage.removeItem('companyData')
        localStorage.setItem('authenticated', false)
        logout({ returnTo: window.location.origin })
        props.setMenuVisible(false)
    }

    const renderDropdownItems = (sectionName) => {
        return MainNav.filter(item => {
            if (sectionName === 'Talento Humano') {
                return isTalentoHumanoItem(item);
            } else if (sectionName === 'Vinculación de Personal') {
                return isVinculacionPersonalItem(item);
            } else if (sectionName === 'Desvinculación de Personal') {
                return isDesvinculacionPersonalItem(item);
            } else if (sectionName === 'Otros') {
                return isOtrosItem(item);
            }
            return false;
        }).map((itemMenu) => {
            if (userRolValidationWithMail(itemMenu.roles, itemMenu.mails, userData)) {
                return (
                    <div key={`dropdownItem_${itemMenu.label}`} className='bm-menu-dropdown-item'>
                        <Link to={itemMenu.to} onClick={() => { props.setMenuVisible(false) }}>
                            <IconButton aria-label={itemMenu.label}>
                                {returnIcon(itemMenu.icon)}
                            </IconButton>
                            <span>{itemMenu.label}</span>
                        </Link>
                    </div>
                );
            }
            return null;
        });
    }

    const returnIcon = (icon) => {
        switch (icon) {
            case 'AiOutlineHome':
                return <AiOutlineHome />
            case 'AiOutlineUser':
                return <AiOutlineUser />
            case 'AiOutlineFileText':
                return <AiOutlineFileText />
            case 'AiOutlineMonitor':
                return <AiOutlineMonitor />
            case 'AiOutlineSchedule':
                return <AiOutlineSchedule />
            case 'AiOutlineFileProtect':
                return <AiOutlineFileProtect />
            case 'AiOutlineMail':
                return <AiOutlineMail />
            case 'AiOutlineUsergroupAdd':
                return <AiOutlineUsergroupAdd />
            case 'AiOutlineClockCircle':
                return <AiOutlineClockCircle />
            case 'AiOutlineDollarCircle':
                return <AiOutlineDollarCircle  />
            case 'CgLogOut':
                return <CgLogOut />
            default:
                return <AiOutlineQuestion />
        }
    }

    const getMenu = () => {
        return MainNav.map((itemMenu, index) => {
            if (userRolValidationWithMail(itemMenu.roles, itemMenu.mails, userData)) {
                // Elementos independientes (Home y Perfil de Usuario)
                if (itemMenu.type === 'item' && isIndependentItem(itemMenu)) {
                    return (
                        <div
                            key={`menuItem_${itemMenu.label}`}
                            className='bm-menu-item'>
                            <Link
                                to={itemMenu.to}
                                onClick={() => { props.setMenuVisible(false) }}
                            >
                                <IconButton
                                    aria-label={itemMenu.label}
                                >
                                    {returnIcon(itemMenu.icon)}
                                </IconButton>
                                <span>{itemMenu.label}</span>
                            </Link>
                        </div>
                    )
                }
                // Botón de logout
                else if (itemMenu.type === 'logout') {
                    return (
                        <div
                            key={`menuItem_${itemMenu.label}`}
                            className='bm-menu-item bm-menu-logout'>
                            <div
                                onClick={handleLogout}
                                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', width: '100%' }}
                            >
                                <IconButton
                                    aria-label={itemMenu.label}
                                >
                                    {returnIcon(itemMenu.icon)}
                                </IconButton>
                                <span>{itemMenu.label}</span>
                            </div>
                        </div>
                    )
                }
                // Secciones con dropdowns
                else if (itemMenu.type === 'section') {
                    return (
                        <div key={`section_${itemMenu.label}`}>
                            <div 
                                className='bm-menu-dropdown-trigger'
                                onClick={() => handleDropdownToggle(itemMenu.label)}
                            >
                                <span>{itemMenu.label}</span>
                                <span className='dropdown-arrow'>{isDropdownOpen(itemMenu.label) ? '▼' : '▶'}</span>
                            </div>
                            {isDropdownOpen(itemMenu.label) && (
                                <div className='bm-menu-dropdown-items'>
                                    {renderDropdownItems(itemMenu.label)}
                                </div>
                            )}
                        </div>
                    )
                }
                // Elementos que no son independientes ni secciones (se renderizan dentro de dropdowns)
                else if (itemMenu.type === 'item' && !isIndependentItem(itemMenu)) {
                    // Estos elementos se renderizan a través de renderDropdownItems
                    return null;
                }
            }
            return null;
        })
    }

    return (
        <div id="outer-container" style={{ height: '100%', width: '20%' }}>
            <Menu
                noOverlay
                isOpen={props.menuVisible}
                onStateChange={(e) => handleStateChange(e)}
                id='slide'
                right={false}
                disableOverlayClick={true}
                disableCloseOnEsc={true}
                disableOverlayClickButton={true}
            >
                {getMenu()}
            </Menu>
        </div>
    );
}

export default connect(mapStateToProps)(GeneralMenu);